import React from 'react';
import PropTypes from 'prop-types';
import { Permissions } from '@upstart/harmony/lib/constants';
import { Confirm } from 'react-confirm-bootstrap';
import { MenuItem } from 'react-bootstrap/lib';
import withDealerPermission from './dealerPermission';

function ImportButton({ dealer, onInventoryImport }) {
  return (
    <Confirm
      onConfirm={() => onInventoryImport(dealer.id)}
      body={`Are you sure you want to import the inventory feeds for ${dealer.name}?`}
      confirmText="Confirm Import"
      title={`Importing inventory for ${dealer.name}`}
    >
      <MenuItem>Import Inventory</MenuItem>
    </Confirm>
  );
}

ImportButton.propTypes = {
  dealer: PropTypes.object,
  onInventoryImport: PropTypes.func,
};

export default withDealerPermission(Permissions.UPDATE)(ImportButton);
